import { http } from "../httpHandler";
import {
  TServerErrorResponse,
  FormFill,
  FormFillUploadResponse,
  FormFillCreateRequest,
  FormFillAiFillMultiRequest,
  FormFillUpdateValuesRequest,
} from "@/types";
import { links } from "@/constants";

export const FORM_FILL_LIST = "FORM_FILL_LIST";
export const FORM_FILL_GET = "FORM_FILL_GET";

export const uploadFormFillPdf = async (
  file: File,
): Promise<FormFillUploadResponse> => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await http.post<FormFillUploadResponse>(
      links.formFill.upload,
      formData,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createFormFill = async (
  data: FormFillCreateRequest,
): Promise<FormFill> => {
  try {
    const response = await http.post<FormFill>(links.formFill.index, data);
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getFormFills = async (params?: {
  skip?: number;
  take?: number;
}): Promise<FormFill[]> => {
  try {
    const response = await http.get<FormFill[]>(links.formFill.index, {
      params,
    });
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getFormFillById = async (id: string): Promise<FormFill> => {
  try {
    const response = await http.get<FormFill>(links.formFill.byId(id));
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteFormFill = async (id: string): Promise<void> => {
  try {
    await http.delete(links.formFill.byId(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateFormFillValues = async (
  id: string,
  data: FormFillUpdateValuesRequest,
): Promise<FormFill> => {
  try {
    const response = await http.patch<FormFill>(
      links.formFill.values(id),
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const aiFillMulti = async (
  id: string,
  data: FormFillAiFillMultiRequest,
): Promise<FormFill> => {
  try {
    const response = await http.post<FormFill>(
      links.formFill.aiFillMulti(id),
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const generateFormFillPdf = async (id: string): Promise<Blob> => {
  try {
    const response = await http.post<Blob>(
      links.formFill.generate(id),
      {},
      {
        responseType: "blob",
        headers: {
          accept: "application/pdf, application/octet-stream, */*",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
